/**
 * @generated SignedSource<<211dedbe64dd7dee92243c9e92d064ba>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuickViewCategory_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useQuickViewCategory_itemSearch">;
  readonly " $fragmentType": "QuickViewCategory_itemSearch";
};
export type QuickViewCategory_itemSearch$key = {
  readonly " $data"?: QuickViewCategory_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuickViewCategory_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickViewCategory_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useQuickViewCategory_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "42ccaaa533725bebe4c0f49e5e8f321c";

export default node;
